/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {SubscriptionFormComponent as ɵc} from './subscription-form/subscription-form.component';
export {SubscriptionComponent as ɵb} from './subscription.component';
export {declaration as ɵa} from './subscription.module';
export {SubscriptionRoutes as ɵd} from './subscription.routing';